import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureSearchResultListStyles {
  root?: IStyle;
  cardView?: IStyle;
}

export interface IFeatureSearchResultListClassNames {
  root: string;
  cardView: string;
}

export const featureSearchResultListStylesDefault = (_theme: IH2OTheme): Partial<IFeatureSearchResultListStyles> => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    marginTop: 16,
  },
  cardView: {
    flex: 1,
    overflow: 'auto',
  },
});
